import i18n from '@dms/i18n';

import {MessageRequirement, MessageSendingRules} from '../types/MessageSendingRules';

const NEXT_SERVICE_DATE: MessageRequirement = {
  icon: 'action/build',
  title: i18n.t('page.settings.scheduledMessages.messageRequirements.nextServiceDate.title'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.nextServiceDate.description'
  ),
};

const INSPECTION_VALID_UNTIL: MessageRequirement = {
  icon: 'action/verified_user',
  title: i18n.t('page.settings.scheduledMessages.messageRequirements.inspectionValidUntil.title'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.inspectionValidUntil.description'
  ),
};

const LINKED_CUSTOMER: MessageRequirement = {
  icon: 'social/person',
  title: i18n.t('page.settings.scheduledMessages.messageRequirements.linkedCustomer.title'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.linkedCustomer.description'
  ),
};

const SCHEDULED_VISIT: MessageRequirement = {
  icon: 'action/event',
  title: i18n.t('page.settings.scheduledMessages.messageRequirements.scheduledVisit.title'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.scheduledVisit.description'
  ),
};

const RESERVED_ORDER: MessageRequirement = {
  icon: 'automotive/car',
  title: i18n.t('page.settings.scheduledMessages.messageRequirements.reservedOrder.title'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.reservedOrder.description'
  ),
};

const RENTED_ORDER: MessageRequirement = {
  icon: 'automotive/rental',
  title: i18n.t('page.settings.scheduledMessages.messageRequirements.rentedOrder.title'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.rentedOrder.description'
  ),
};

const SERVICE_ORDER_CONTACT: MessageRequirement = {
  icon: 'communication/phone',
  title: i18n.t('page.settings.scheduledMessages.messageRequirements.serviceOrderContact.title'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.serviceOrderContact.description'
  ),
};

const BUSINESS_CASE_CONTACT: MessageRequirement = {
  icon: 'communication/phone',
  title: i18n.t('page.settings.scheduledMessages.messageRequirements.businessCaseContact.title'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.businessCaseContact.description'
  ),
};

const ACTIVE_RESERVATION: MessageRequirement = {
  icon: 'automotive/car',
  title: i18n.t('page.settings.scheduledMessages.messageRequirements.activeReservation.title'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.activeReservation.description'
  ),
};
const RESERVATION_CUSTOMER: MessageRequirement = {
  icon: 'social/person',
  title: i18n.t('page.settings.scheduledMessages.messageRequirements.reservationCustomer.title'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.reservationCustomer.description'
  ),
};
const ACTIVE_RESERVATION_WITH_END_DATE: MessageRequirement = {
  icon: 'action/event',
  title: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.activeReservationWithEndDate.title'
  ),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.activeReservationWithEndDate.description'
  ),
};
const BUSINESS_CASE_CONCEPT_OR_OFFER: MessageRequirement = {
  icon: 'action/subject',
  title: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.businessCaseConceptOrOffer.title'
  ),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.businessCaseConceptOrOffer.description'
  ),
};
const SALE_ONLINE_OFFER_WITH_VALIDITY: MessageRequirement = {
  icon: 'action/event',
  title: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.saleOnlineOfferWithValidity.title'
  ),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.saleOnlineOfferWithValidity.description'
  ),
};
const BUSINESS_CASE_IN_OFFER: MessageRequirement = {
  icon: 'action/subject',
  title: i18n.t('page.settings.scheduledMessages.messageRequirements.businessCaseInOffer.title'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.businessCaseInOffer.description'
  ),
};
const DEPOSIT_PAYMENT_BANK_TRANSFER: MessageRequirement = {
  icon: 'action/subject',
  title: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.depositPaymentBankTransfer.title'
  ),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.depositPaymentBankTransfer.description'
  ),
};
const DEPOSIT_PAYMENT_CONFIRMED: MessageRequirement = {
  icon: 'action/check_circle',
  title: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.depositPaymentConfirmed.title'
  ),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.depositPaymentConfirmed.description'
  ),
};
const BALANCE_PAYMENT_BANK_TRANSFER: MessageRequirement = {
  icon: 'action/subject',
  title: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.balancePaymentBankTransfer.title'
  ),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.balancePaymentBankTransfer.description'
  ),
};
const BALANCE_PAYMENT_CONFIRMED: MessageRequirement = {
  icon: 'action/check_circle',
  title: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.balancePaymentConfirmed.title'
  ),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.balancePaymentConfirmed.description'
  ),
};
const OVERDUE_BANK_TRANSFER_PAYMENT: MessageRequirement = {
  icon: 'action/event',
  title: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.overdueBankTransferPayment.title'
  ),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.overdueBankTransferPayment.description'
  ),
};
const DIGITALLY_SIGNED_CONTRACT: MessageRequirement = {
  icon: 'action/subject',
  title: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.digitallySignedContract.title'
  ),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.digitallySignedContract.description'
  ),
};
const COMPLAINT_WITH_CUSTOMER: MessageRequirement = {
  icon: 'social/person',
  title: i18n.t('page.settings.scheduledMessages.messageRequirements.complaintWithCustomer.title'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.complaintWithCustomer.description'
  ),
};
const CLOSED_COMPLAINT_WITH_RESULT: MessageRequirement = {
  icon: 'action/check_circle',
  title: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.closedComplaintWithResult.title'
  ),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.closedComplaintWithResult.description'
  ),
};
const PLANNED_TEST_DRIVE_WITH_VEHICLE_AND_CUSTOMER: MessageRequirement = {
  icon: 'automotive/car',
  title: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.plannedTestDriveWithVehicleAndCustomer.title'
  ),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.plannedTestDriveWithVehicleAndCustomer.description'
  ),
};
const PLANNED_TEST_DRIVE_WITH_DATE: MessageRequirement = {
  icon: 'action/event',
  title: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.plannedTestDriveWithDate.title'
  ),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.plannedTestDriveWithDate.description'
  ),
};
const INTEREST_WITH_CUSTOMER: MessageRequirement = {
  icon: 'social/person',
  title: i18n.t('page.settings.scheduledMessages.messageRequirements.interestWithCustomer.title'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.interestWithCustomer.description'
  ),
};
const SOURCE_SELECTED_IN_ROW: MessageRequirement = {
  icon: 'action/subject',
  title: i18n.t('page.settings.scheduledMessages.messageRequirements.sourceSelectedInRow.title'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.sourceSelectedInRow.description'
  ),
};
const OPEN_INTEREST: MessageRequirement = {
  icon: 'action/subject',
  title: i18n.t('entity.activityPanel.activity.actions.openInterest'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.openInterest.description'
  ),
};
const MESSAGE_SENT_TO_CUSTOMER: MessageRequirement = {
  icon: 'communication/phone',
  title: i18n.t('page.settings.scheduledMessages.messageRequirements.messageSentToCustomer.title'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.messageSentToCustomer.description'
  ),
};
const OFFERED_VEHICLE_ON_INTEREST: MessageRequirement = {
  icon: 'automotive/car',
  title: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.offeredVehicleOnInterest.title'
  ),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.offeredVehicleOnInterest.description'
  ),
};

const TIRE_SET_IN_STOCK_WITH_STORE_UNTIL: MessageRequirement = {
  icon: 'action/event',
  title: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.tireSetInStockWithStoreUntil.title'
  ),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.tireSetInStockWithStoreUntil.description'
  ),
};
const TIRE_SET_CONTACT_PERSON: MessageRequirement = {
  icon: 'communication/phone',
  title: i18n.t('page.settings.scheduledMessages.messageRequirements.tireSetContactPerson.title'),
  description: i18n.t(
    'page.settings.scheduledMessages.messageRequirements.tireSetContactPerson.description'
  ),
};

export const MESSAGE_SENDING_RULES: Record<string, MessageSendingRules> = {
  'business_case-thank_you_after_sale': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.thankYouAfterSale'),
    requirements: [],
  },
  'business_case-check_in_after_sale': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.checkInAfterSale'),
    requirements: [BUSINESS_CASE_CONTACT],
  },
  'business_case-reservation_confirmation': {
    when: i18n.t(
      'page.settings.scheduledMessages.messageRequirements.when.reservationConfirmation'
    ),
    requirements: [ACTIVE_RESERVATION, RESERVATION_CUSTOMER],
  },
  'business_case-reservation_expiring': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.reservationExpiring'),
    requirements: [ACTIVE_RESERVATION_WITH_END_DATE, BUSINESS_CASE_CONCEPT_OR_OFFER],
  },
  'business_case-online_offer_expiring': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.onlineOfferExpiring'),
    requirements: [SALE_ONLINE_OFFER_WITH_VALIDITY, BUSINESS_CASE_IN_OFFER],
  },
  'business_case-deposit_payment_request': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.depositPaymentRequest'),
    requirements: [DEPOSIT_PAYMENT_BANK_TRANSFER],
  },
  'business_case-deposit_received': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.depositReceived'),
    requirements: [DEPOSIT_PAYMENT_CONFIRMED],
  },
  'business_case-balance_payment_request': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.balancePaymentRequest'),
    requirements: [BALANCE_PAYMENT_BANK_TRANSFER],
  },
  'business_case-payment_received': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.paymentReceived'),
    requirements: [BALANCE_PAYMENT_CONFIRMED],
  },
  'business_case-payment_overdue_reminder': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.paymentOverdueReminder'),
    requirements: [OVERDUE_BANK_TRANSFER_PAYMENT],
  },
  'business_case-contract_signed': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.contractSigned'),
    requirements: [DIGITALLY_SIGNED_CONTRACT],
  },
  'complaint-received': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.complaintReceived'),
    requirements: [COMPLAINT_WITH_CUSTOMER],
  },
  'complaint-closed': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.complaintClosed'),
    requirements: [CLOSED_COMPLAINT_WITH_RESULT],
  },
  'test_drive-scheduled': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.testDriveScheduled'),
    requirements: [PLANNED_TEST_DRIVE_WITH_VEHICLE_AND_CUSTOMER],
  },
  'test_drive-reminder': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.testDriveReminder'),
    requirements: [PLANNED_TEST_DRIVE_WITH_DATE],
  },
  'interest-received': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.interestReceived'),
    requirements: [INTEREST_WITH_CUSTOMER, SOURCE_SELECTED_IN_ROW],
  },
  'interest-no_response_follow_up': {
    when: i18n.t(
      'page.settings.scheduledMessages.messageRequirements.when.interestNoResponseFollowUp'
    ),
    requirements: [OPEN_INTEREST, MESSAGE_SENT_TO_CUSTOMER, OFFERED_VEHICLE_ON_INTEREST],
  },
  'vehicle-regular_service_inspection_reminder': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.regularService'),
    requirements: [NEXT_SERVICE_DATE, LINKED_CUSTOMER],
  },
  'tire_set-storage_end_reminder': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.tireSetStorageEnd'),
    requirements: [TIRE_SET_IN_STOCK_WITH_STORE_UNTIL, TIRE_SET_CONTACT_PERSON],
  },
  'vehicle-inspection_expiration_reminder': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.inspectionExpiration'),
    requirements: [INSPECTION_VALID_UNTIL, LINKED_CUSTOMER],
  },
  'workshop-service_case_visit_reminder': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.serviceCaseVisit'),
    requirements: [SCHEDULED_VISIT],
  },
  'rental_order-rent_reminder': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.rentalOrderRent'),
    requirements: [RESERVED_ORDER],
  },
  'rental_order-handover_reminder': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.rentalOrderHandover'),
    requirements: [RENTED_ORDER],
  },
  'rental_order-reservation_confirmation': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.rentalOrderReservation'),
    requirements: [],
  },
  'workshop-service_order_planned': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.serviceOrderPlanned'),
    requirements: [],
  },
  'workshop-service_order_completed': {
    when: i18n.t('page.settings.scheduledMessages.messageRequirements.when.serviceOrderCompleted'),
    requirements: [SERVICE_ORDER_CONTACT],
  },
};
